import { Response } from '@angular/http';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Tuple, Tuple3 } from '../../entities/global/model';
import { catchError } from 'rxjs/operators';
import { SystemDetails } from '../manage-equipment/models/manage-equipment.model';
import { ThermographyLinkPinVM, ThermographynspectionVM, ThermographyInspectionDataVM, ThermographyInfoVM } from './thermography-inspection.model';
import { AddComponentPhotoModel } from '../interpretation/models/interpretation.model';
import { AdditionalComponentsVM, ModelSelectionFilter } from '../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';

@Injectable()

export class ThermographyInspectionService {
  private readonly API_BASE = 'api/ThermographyInspection/';
  private readonly GetPinsforModel = this.API_BASE + 'GetPinsforModelByEquipment';
  private readonly CreateInspection = this.API_BASE + 'CreateInspectionDraft';
  private readonly VALIDATE_SMU_DATE_TEMP_INSPECTION = this.API_BASE + 'ValidateDateSMU';
  private readonly GetInspectionDetails = this.API_BASE + 'GetThermographyInspectionDetails';
  private readonly UpdateComment = this.API_BASE + 'UpdateThermographyComment';
  private readonly UpdateEvaluation = this.API_BASE + 'UpdateThermographyDeatilEval';
  private readonly UpdateDetailComment = this.API_BASE + 'UpdateThermographyDeatilComment';
  private readonly UpdateThermographyDocument = this.API_BASE + 'UpdateThermographyDocument';

  private readonly UpdateDetailCommentWSRE = this.API_BASE + 'UpdateWSREDeatilComment';

  private readonly UPDATE_THERMO_INSPECTION_DETAIL_PHOTO = this.API_BASE + 'UpdateThermographyDeatilPhoto';
  private readonly DELETE_THERMO_INSPECTION_DETAIL_PHOTO = this.API_BASE + 'DeleteThermographyDeatilPhoto';
  private readonly GetSpecifcInspectionDetails = this.API_BASE + 'LoadSpecificThermographyInspectionDetails';
  private readonly UpdateTrackSagInfo= this.API_BASE + 'UpdateInspectionTrackSag';
  private readonly UpdateSMU= this.API_BASE + 'UpdateInspectionSMU';
  private readonly UpdateDate= this.API_BASE + 'UpdateInspectionDate';
  private readonly UpdateReleaseInspection = this.API_BASE + 'ReleaseInspection';
  private readonly LoadAdditionalComponets = this.API_BASE + 'LoadAllAdditionalComponetsForModel';
  private readonly UpdateThermographyAdditionalComponent = this.API_BASE + 'UpdateThermographyAdditionalComponent';
  private readonly GetAdditionalComponentImage = this.API_BASE + 'GetAdditionalComponentImage';

  private readonly CreateNewThermogarphyAdditionalComponent = this.API_BASE + 'CreateNewThermogarphyAdditionalComponent';


  

  
  




  

  
  


  

  constructor(private _http: HttpClient ) { }


  public GetPinsforModelByEquipment(equipmentId: number): Observable<ThermographyLinkPinVM[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GetPinsforModel, options).pipe(catchError(this.handleError));
  }

  public CreateThermogarphyInspection(equipmentId: number,SMU:number,InspectionDate:string): Observable<number> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('SMU', SMU.toString()).set('InspectionDate', InspectionDate.toString())
    };
    return this._http.get(this.CreateInspection, options).pipe(catchError(this.handleError));
  }

  public GetThermogarphyInspectionInfo(equipmentId: number,InspectionId:number): Observable<ThermographyInspectionDataVM> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('InspectionId', InspectionId.toString())
    };
    return this._http.get(this.GetInspectionDetails, options).pipe(catchError(this.handleError));
  }
  public GetSpecificThermogarphyInspectionInfo(Side:number,system:number,InspectionId: number,EquipmentId:number): Observable<ThermographyInfoVM[]> {
    const options = {
      params: new HttpParams().set('Side', Side.toString()).set('system', system.toString()).set('InspectionId', InspectionId.toString()).set('EquipmentId', EquipmentId.toString())
    };
    return this._http.get(this.GetSpecifcInspectionDetails, options).pipe(catchError(this.handleError));
  }

  public UpdateRelease(InspectionId:number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionId', InspectionId.toString())
    };
    return this._http.get(this.UpdateReleaseInspection, options).pipe(catchError(this.handleError));
  }
  
  public ValidateSMUAndDate(model: ThermographynspectionVM): Observable<Tuple3> {
    return this._http.post(this.VALIDATE_SMU_DATE_TEMP_INSPECTION, model).pipe(catchError(this.handleError));
  }
  public UpdateThermographyComment(InspectionId:number, newComment:string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionId', InspectionId.toString()).set('newComment', newComment.toString())
    };
    return this._http.get(this.UpdateComment, options).pipe(catchError(this.handleError));
  }


  public UpdateTrackSag(InspectionId:number, value:number, side:number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionId', InspectionId.toString()).set('value', value.toString()).set('side', side.toString())
    };
    return this._http.get(this.UpdateTrackSagInfo, options).pipe(catchError(this.handleError));
  }

  
  public UpdateThermoSMU(InspectionId:number, smu:number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionId', InspectionId.toString()).set('smu', smu.toString())
    };
    return this._http.get(this.UpdateSMU, options).pipe(catchError(this.handleError));
  }

  public UpdateThermoInspectionDate(InspectionId:number, date:string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionId', InspectionId.toString()).set('date', date.toString())
    };
    return this._http.get(this.UpdateDate, options).pipe(catchError(this.handleError));
  }
  
  public UpdateThermographyEval(InspectionDetailId:number, newEval:string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionDetailId', InspectionDetailId.toString()).set('newEval', newEval.toString())
    };
    return this._http.get(this.UpdateEvaluation, options).pipe(catchError(this.handleError));
  }

  public updateInspectionDetailComment(InspectionDetailId:number, newComment:string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionDetailId', InspectionDetailId.toString()).set('newComment', newComment.toString())
    };
    return this._http.get(this.UpdateDetailComment, options).pipe(catchError(this.handleError));
  }

 
  

  public updateThermographyDocument(document: AddComponentPhotoModel): Observable<Tuple> {
    return this._http.post(this.UpdateThermographyDocument, document).pipe(catchError(this.handleError));
  }
  
  public updateInspectionDetailCommentWSRE(InspectionDetailId:number, newComment:string, screenId:number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionDetailId', InspectionDetailId.toString()).set('newComment', newComment.toString()).set('ScreenId', screenId.toString())
    };
    return this._http.get('api/wsre/UpdateWSREDeatilComment', options).pipe(catchError(this.handleError));
  }
  public addThermogarphyInspectionDetailPhoto(photo: AddComponentPhotoModel): Observable<Tuple> {
    return this._http.post(this.UPDATE_THERMO_INSPECTION_DETAIL_PHOTO, photo).pipe(catchError(this.handleError));
  }
  

  public deleteThermographyInspectionDetailPhoto(inspectionDetailId: number): Observable<boolean> {
    const options = {
      params: new HttpParams()
      .set('inspectionDetailId', inspectionDetailId.toString())
    };
    return this._http.get(this.DELETE_THERMO_INSPECTION_DETAIL_PHOTO, options).pipe(catchError(this.handleError));
  }

  public GETAllAddditionalComponentsForModel(selectedModelList: number[]): Observable<AdditionalComponentsVM[]> {
    return this._http.post<AdditionalComponentsVM[]>(this.LoadAdditionalComponets, selectedModelList).pipe(catchError(this.handleError));
  }
 
  public UpdateThermographyAdditionalComponentDetails(info: AdditionalComponentsVM): Observable<boolean> {
    return this._http.post(this.UpdateThermographyAdditionalComponent, info).pipe(catchError(this.handleError));
  }

  public GETThermogarphyAdditonalCompImage(AdditionalCompId: number): Observable<string> {
    const options = {
      params: new HttpParams()
      .set('AdditionalCompId', AdditionalCompId.toString())
    };
    return this._http.get(this.GetAdditionalComponentImage, options).pipe(catchError(this.handleError));
  }

  public CreateNewAdditionalComponet(info: AdditionalComponentsVM): Observable<boolean> {
    return this._http.post(this.CreateNewThermogarphyAdditionalComponent, info).pipe(catchError(this.handleError));
  }
  private handleError(err: HttpErrorResponse): Observable<any> {
    console.log('handled error ' + err.status);
    return  Observable.throw(err || 'Server error');
  }

}
